import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Certification from '../../../CertificationsAndTraining/Certifications/Certification';

class ProfileCertification extends Component {
  static propTypes = {
    creditTypes: PropTypes.array,
    user: PropTypes.object,
    updateUser: PropTypes.func,
    updateUserPayments: PropTypes.func,
  };

  render() {
    const { user } = this.props;

    return (
      <Certification
        {...this.props}
        user={user}
        certifications={user.userCertifications}
        certificationPayments={user.certificationPayments}
      />
    );
  }
}

export default ProfileCertification;
